import * as React from 'react';
import { CssBaseline, AppBar, Toolbar, Typography, Theme, createStyles, withStyles, WithStyles, Button } from '@material-ui/core';
import strings from 'src/strings';
import { RouteComponentProps, withRouter } from 'react-router';
import { withUser, WithUser } from '../HOC/User';

const styles = (theme: Theme) => createStyles({
    appBar: {
        position: 'relative',
    },
    toolbarImageContainer: {
        flex: 1,
    },
    toolbarImage: {
        width: 'auto',
        paddingTop: 10,
        paddingBottom: 10
    },
    rightToolBar: {
    },
    rightButton: {
        marginLeft: theme.spacing()
    }
})

class WelcomHeader extends React.Component<WithStyles<typeof styles> & RouteComponentProps & WithUser> {

    public render() {
        const { classes } = this.props
        return (
            <React.Fragment>
                <CssBaseline />
                <AppBar position="absolute" color="default" className={classes.appBar}>
                    <Toolbar className={classes.rightToolBar}>
                        <div className={classes.toolbarImageContainer}>
                            <img src={require('../../assets/logo.png')} className={classes.toolbarImage} />
                        </div>
                        <Button onClick={() => this.props.history.push('/')}>{strings.welcome}</Button>
                        <Button onClick={() => this.props.history.push('/pricing')}>{strings.pricing}</Button>
                        <Button onClick={() => this.props.history.push('/toc')}>{strings.termsAndConditions}</Button>
                        {this.props.user && <>
                            <Button onClick={() => this.props.history.push('/app/dashboard')}>{strings.dashboard}</Button>
                            <Button className={classes.rightButton} color="primary" variant="outlined" onClick={() => this.props.history.push('/logout')}>
                                {strings.logout}
                            </Button>
                        </>}
                        {!this.props.user && <>
                            <Button onClick={() => this.props.history.push('/sign-up')}>Sign Up</Button>
                            <Button className={classes.rightButton} color="primary" variant="outlined" onClick={() => this.props.history.push('/login')}>
                                {strings.login}
                            </Button>
                        </>}
                    </Toolbar>
                </AppBar>
            </React.Fragment >
        )
    }
}
export default withUser(withStyles(styles)(withRouter(WelcomHeader)))


// WEBPACK FOOTER //
// ./src/components/Header/WelcomeHeader.tsx